import React from 'react';

import { FieldPropsContext } from '../../../../contexts/field-props-context';
import { useForm } from '../../../../contexts/form-context';
import { type FieldLayoutComponent } from '../../../../field-layout';
import { useExternalData } from '../../contexts/external-data-context';
import { useFormFields } from '../../contexts/form-fields-context';
import { type ReadOnlyField as ReadOnlyFieldEntity } from '../../types';

export interface ReadOnlyFieldProps {
  field: ReadOnlyFieldEntity;
  FieldLayout: FieldLayoutComponent;
}

export const ReadOnlyField = ({ field, FieldLayout }: ReadOnlyFieldProps) => {
  const componentsById = useFormFields();
  const externalData = useExternalData();
  const form = useForm();

  const { requiredIndicator, requiredIndicatorPlacement } =
    form.requiredIndicatorProperties || {};
  const FieldComponent = componentsById[field.fieldType];

  if (!FieldComponent) {
    return null;
  }

  const fieldProps = {
    ...field.properties,
    id: field.id,
    externalData,
    fieldType: field.fieldType,
    FieldLayout,
    requiredIndicatorType: requiredIndicator,
    requiredIndicatorPlacement,
  };

  return (
    <FieldPropsContext.Provider value={{ v2: fieldProps }}>
      <FieldComponent {...fieldProps} />
    </FieldPropsContext.Provider>
  );
};
